import i18next, { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './resources';
import { fallbackLng, languages } from './settings';

/**
 * Translations are bundled, so init can run synchronously (`initAsync:
 * false`). That lets the provider render on the very first pass — including
 * on the server — instead of returning null until a promise resolves.
 */
export function createI18n(lng: string): typeof i18next {
  const i18nInstance = createInstance(); // create a new i18next instance
  i18nInstance.use(initReactI18next); // pass the instance to react-i18next

  i18nInstance.init({
    lng,
    resources, // our translations
    fallbackLng, // fallback language if something is missing
    supportedLngs: languages, // limit supported languages to these
    defaultNS: 'common', // default namespace (we use "common")
    interpolation: { escapeValue: false }, // not needed for React (no XSS issues)
    initAsync: false
  });

  return i18nInstance;
}

async function initI18next(lng: string): Promise<typeof i18next> {
  return createI18n(lng);
}

export default initI18next;
